import React, { useRef, useEffect } from 'react';

const PreviewWindow = ({ html }) => {
  const iframeRef = useRef(null);

  useEffect(() => {
    const iframe = iframeRef.current;
    if (!iframe) return;

    const document = iframe.contentDocument;
    if (document) {
      document.open();
      document.write(html);
      document.close();
    }
  }, [html]);

  return (
    <div style={{ border: '3px solid #26e07f', margin: '20px auto', width: '80%', padding: `10px`}}>
      <iframe
        ref={iframeRef}
        title="Live Preview"
        style={{ width: '100%', height: '400px', border: 'none' }}
        sandbox="allow-scripts allow-same-origin"
      />
    </div>
  );
};

export default PreviewWindow;
